export default {
  unPaidCashList: {
    data: null,
    loading: false,
    error: null,
  },
};
